"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("@emotion/react");

// Global base style
var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("body{font-family:", theme.font.primary, ";color:", theme.color.monochrome.black, ";line-height:", theme.lineHeight.leadingNormal, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var _default = base;
exports["default"] = _default;
//# sourceMappingURL=base.js.map